// NEXT_PUBLIC_BACKEND_URL conventionally includes the trailing /api (see
// lib/api.ts), but some environments configure it without the suffix.
// Normalize so callers can build /api/... URLs safely under both conventions.
export function backendApiUrl(path: string, rawBase?: string): string {
  const raw = rawBase ?? process.env.NEXT_PUBLIC_BACKEND_URL ?? '';
  const base = raw.replace(/\/api\/?$/, '').replace(/\/$/, '');
  return `${base}/api${path.startsWith('/') ? path : `/${path}`}`;
}
